import type { Command } from 'commander';
import { registerPersonalResumesCommand } from './resumes';
import { registerPersonalApplyCommand } from './apply';

export function registerPersonalCommand(program: Command): void {
	const personal = program.command('personal').description('Manage your personal resumes, profile and applications');
	registerPersonalResumesCommand(personal);
	registerPersonalApplyCommand(personal);
}
